export const DRAWER_SEARCH_PARAM_ITEM_ID = 'drawerItemId' as const;
